import { useEffect, useState } from "react";
import Toast from "./Toast";

const ToastContainer = ({ position = "top-right", maxToasts = 5 }) => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    // Listen for toast events
    const handleShowToast = (event) => {
      const { variant, title, message, duration, icon, showCloseButton } =
        event.detail;

      const newToast = {
        id: Date.now() + Math.random(),
        variant: variant || "info",
        title,
        message,
        duration: duration !== undefined ? duration : 5000,
        position: event.detail.position || position,
        icon,
        showCloseButton: showCloseButton !== undefined ? showCloseButton : true,
      };

      setToasts((prev) => {
        const filtered = prev.filter((t) => t.position === newToast.position);
        const updated = [...filtered, newToast];
        return updated.slice(-maxToasts);
      });
    };

    window.addEventListener("show-toast", handleShowToast);

    return () => {
      window.removeEventListener("show-toast", handleShowToast);
    };
  }, [position, maxToasts]);

  const handleClose = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  // Group toasts by position
  const groupedToasts = toasts.reduce((acc, toast) => {
    const pos = toast.position || position;
    if (!acc[pos]) {
      acc[pos] = [];
    }
    acc[pos].push(toast);
    return acc;
  }, {});

  const getPositionStyles = (pos) => {
    const baseStyles = {
      position: "fixed",
      zIndex: 50,
      pointerEvents: "none",
    };

    switch (pos) {
      case "top-left":
        return { ...baseStyles, top: "1rem", left: "1rem" };
      case "top-center":
        return {
          ...baseStyles,
          top: "1rem",
          left: "50%",
          transform: "translateX(-50%)",
        };
      case "top-right":
        return { ...baseStyles, top: "1rem", right: "1rem" };
      case "bottom-left":
        return { ...baseStyles, bottom: "1rem", left: "1rem" };
      case "bottom-center":
        return {
          ...baseStyles,
          bottom: "1rem",
          left: "50%",
          transform: "translateX(-50%)",
        };
      case "bottom-right":
        return { ...baseStyles, bottom: "1rem", right: "1rem" };
      default:
        return { ...baseStyles, top: "1rem", right: "1rem" };
    }
  };

  return (
    <>
      {Object.entries(groupedToasts).map(([pos, positionToasts]) => (
        <div key={pos} style={getPositionStyles(pos)}>
          {positionToasts.map((toast, index) => (
            <div
              key={toast.id}
              style={{
                marginBottom: index < positionToasts.length - 1 ? "12px" : "0",
              }}
            >
              <Toast {...toast} onClose={handleClose} />
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default ToastContainer;
